import { useTranslation } from 'react-i18next';
import { useUserGeneratedContent } from '../../../../models/user-generated-contents/context';
import { MAXIMUM_SUMMARY_LENGTH } from '../../../../models/user-generated-contents/context';
import { ReferenceTextInput } from '../../../../components/ui/reference-text-input';
import { useFeatureFlag } from '../../../../common/use-feature-flag';
import { Feature } from '../../../../models/features/features';
import '../form.scss';

const DescriptionInput = () => {
  const {
    userGeneratedContent,
    isPersisting,
    updateUserGeneratedContentFormState,
  } = useUserGeneratedContent();
  const { t } = useTranslation();
  const mentionsEnabled = !!useFeatureFlag(Feature.TAG_USER_ENABLED);

  const onTextChange = (summary: string) => {
    updateUserGeneratedContentFormState({ summary });
  };

  return (
    <>
      <div className="ugc__editor-input-wrapper ugc__editor-description-wrapper">
        <ReferenceTextInput
          mentionsEnabled={mentionsEnabled}
          placeholder={t(
            'user_generated_content.field_description_placeholder'
          )}
          fullWidth
          value={userGeneratedContent.summary || ''}
          onChange={onTextChange}
          disabled={isPersisting}
          maxLength={MAXIMUM_SUMMARY_LENGTH}
          allowExceedingMaxLength
          className={'ugc__description-input-fieldset'}
          inputClassName={'ugc__description-input'}
          aria-label={t('user_generated_content.field_description')}
          showCharacterCounter
          variant="borderless"
          size="compact"
        />
      </div>
    </>
  );
};

export default DescriptionInput;
